import React, { useEffect, useState } from "react";

import Textarea from "components/atoms/Textarea";
import Button from "components/atoms/button";

import {
    ActionGroup,
    ActionRow,
    FormSection,
    HelperText,
    PanelCard,
    PanelHeader,
    PanelHeaderAside,
    PanelHeaderMain,
    PanelTitle,
    PhaseBadge,
    ProgressNote,
} from "components/organisms/report/styled";

const phaseLabel = (streaming) => (streaming ? "계획 생성 중" : "수정 가능");

export default function PlanningStepSection({ planningState, onConfirmPlanning, onGoBackRequest }) {
    const [editablePlanText, setEditablePlanText] = useState("");

    useEffect(() => {
        setEditablePlanText(planningState.planText || "");
    }, [planningState.planText]);

    const displayedPlanText = planningState.streaming ? planningState.streamBuffer || "" : editablePlanText;
    const hasPlanText = !!displayedPlanText.trim();

    const handleConfirmPlanning = () => {
        const planText = displayedPlanText.trim();
        if (!planText) return;
        onConfirmPlanning(planText);
    };

    return (
        <PanelCard>
            <PanelHeader>
                <PanelHeaderMain>
                    <PanelTitle>연구 계획 검토</PanelTitle>
                    <HelperText>에이전트가 만든 계획을 확인하고 필요한 내용을 수정한 뒤 분석을 시작하세요.</HelperText>
                </PanelHeaderMain>
                <PanelHeaderAside>
                    <PhaseBadge kind={planningState.streaming ? "progress" : "done"}>
                        {phaseLabel(planningState.streaming)}
                    </PhaseBadge>
                </PanelHeaderAside>
            </PanelHeader>

            {planningState.streaming && (
                <ProgressNote>
                    계획 초안을 작성하고 있습니다. 생성이 끝나면 아래 편집 영역에서 내용을 조정할 수 있습니다.
                </ProgressNote>
            )}

            <FormSection>
                <Textarea
                    placeholder="연구 계획을 입력하세요."
                    value={displayedPlanText}
                    onChange={(e) => setEditablePlanText(e.target.value)}
                    saveAct={(e) => {}}
                    disabled={planningState.streaming}
                    maxWidth="100%"
                />
            </FormSection>

            <ActionRow>
                <ActionGroup>
                    <Button
                        onlyText
                        width={"140px"}
                        height={"44px"}
                        size={"small"}
                        bgColor={"var(--color-Button3)"}
                        hoverBgColor={"var(--color-ButtonHover3)"}
                        fontColor={"var(--color-White)"}
                        buttonText={"이전 단계"}
                        onClick={onGoBackRequest}
                    />
                </ActionGroup>
                <ActionGroup>
                    <Button
                        onlyText
                        width={"140px"}
                        height={"44px"}
                        size={"small"}
                        bgColor={"var(--color-Button1)"}
                        hoverBgColor={"var(--color-ButtonHover1)"}
                        fontColor={"var(--color-White)"}
                        buttonText={"분석 시작"}
                        onClick={handleConfirmPlanning}
                        disabled={planningState.streaming || !hasPlanText}
                    />
                </ActionGroup>
            </ActionRow>
        </PanelCard>
    );
}
